import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

import { ta } from '../../i18n/adminT';
export default function ChangePassword() {
  // --- Email ---
  const [currentEmail, setCurrentEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [emailPassword, setEmailPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [savingEmail, setSavingEmail] = useState(false);

  // --- Password ---
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [savingPassword, setSavingPassword] = useState(false);

  // --- 2FA (facoltativa) ---
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [totpEnabled, setTotpEnabled] = useState(false);
  const [twoFaStep, setTwoFaStep] = useState('idle'); // idle | setup | disable
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const [manualEntryKey, setManualEntryKey] = useState('');
  const [enableCode, setEnableCode] = useState('');
  const [disablePassword, setDisablePassword] = useState('');
  const [twoFaError, setTwoFaError] = useState('');
  const [twoFaBusy, setTwoFaBusy] = useState(false);

  useEffect(() => {
    api.me().then((me) => {
      setCurrentEmail(me.email || '');
      setNewEmail(me.email || '');
      setIsSupervisor(Boolean(me.isSupervisor));
      setTotpEnabled(Boolean(me.totpEnabled));
    });
  }, []);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');
    setEmailSuccess(false);

    if (!newEmail.trim()) {
      setEmailError(ta("L'email non può essere vuota."));
      return;
    }
    if (newEmail.trim() === currentEmail) {
      setEmailError(ta('Questa è già la tua email attuale.'));
      return;
    }
    if (!emailPassword) {
      setEmailError(ta('Inserisci la password attuale per confermare.'));
      return;
    }

    setSavingEmail(true);
    try {
      const res = await api.changeEmail(newEmail.trim(), emailPassword);
      setCurrentEmail(res.email);
      setEmailPassword('');
      setEmailSuccess(true);
    } catch (err) {
      setEmailError(err.message);
    } finally {
      setSavingEmail(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess(false);

    if (newPassword.length < 8) {
      setPasswordError(ta('La nuova password deve avere almeno 8 caratteri.'));
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError(ta('La conferma non corrisponde alla nuova password.'));
      return;
    }

    setSavingPassword(true);
    try {
      await api.changePassword(currentPassword, newPassword);
      setPasswordSuccess(true);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setPasswordError(err.message);
    } finally {
      setSavingPassword(false);
    }
  };

  const handleStartEnable2fa = async () => {
    setTwoFaError('');
    setTwoFaBusy(true);
    try {
      const res = await api.enable2faInit();
      setQrCodeDataUrl(res.qrCodeDataUrl);
      setManualEntryKey(res.manualEntryKey);
      setTwoFaStep('setup');
    } catch (err) {
      setTwoFaError(err.message);
    } finally {
      setTwoFaBusy(false);
    }
  };

  const handleConfirmEnable2fa = async (e) => {
    e.preventDefault();
    setTwoFaError('');
    setTwoFaBusy(true);
    try {
      await api.enable2faConfirm(enableCode);
      setTotpEnabled(true);
      setTwoFaStep('idle');
      setEnableCode('');
    } catch (err) {
      setTwoFaError(err.message);
    } finally {
      setTwoFaBusy(false);
    }
  };

  const handleDisable2fa = async (e) => {
    e.preventDefault();
    setTwoFaError('');
    setTwoFaBusy(true);
    try {
      await api.disable2fa(disablePassword);
      setTotpEnabled(false);
      setDisablePassword('');
      setTwoFaStep('idle');
    } catch (err) {
      setTwoFaError(err.message);
    } finally {
      setTwoFaBusy(false);
    }
  };

  const cancelTwoFaFlow = () => {
    setTwoFaStep('idle');
    setTwoFaError('');
    setEnableCode('');
    setDisablePassword('');
  };

  return (
    <div>
      <h1 className="admin-page-title">{ta('Il mio account')}</h1>
      <p className="admin-page-subtitle">{ta('Gestisci l\'email e la password del tuo account amministratore.')}</p>

      <div className="admin-card" style={{ maxWidth: 420 }}>
        <h3 style={{ marginBottom: 14 }}>{ta('Email')}</h3>
        {emailError && <div className="form-error">{emailError}</div>}
        {emailSuccess && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {ta('Email aggiornata correttamente.')}
          </div>
        )}

        <form onSubmit={handleEmailSubmit}>
          <div className="field">
            <label htmlFor="new-email">{ta('Nuova email')}</label>
            <input
              id="new-email"
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              autoComplete="email"
            />
          </div>
          <div className="field">
            <label htmlFor="email-password">{ta('Password attuale (per confermare)')}</label>
            <input
              id="email-password"
              type="password"
              value={emailPassword}
              onChange={(e) => setEmailPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button className="btn btn-primary" disabled={savingEmail}>
            {savingEmail ? ta('Aggiornamento…') : ta('Aggiorna email')}
          </button>
        </form>
      </div>

      <div className="admin-card" style={{ maxWidth: 420 }}>
        <h3 style={{ marginBottom: 14 }}>{ta('Password')}</h3>
        {passwordError && <div className="form-error">{passwordError}</div>}
        {passwordSuccess && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {ta('Password aggiornata correttamente.')}
          </div>
        )}

        <form onSubmit={handlePasswordSubmit}>
          <div className="field">
            <label htmlFor="current-password">{ta('Password attuale')}</label>
            <input
              id="current-password"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <div className="field">
            <label htmlFor="new-password">{ta('Nuova password')}</label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div className="field">
            <label htmlFor="confirm-password">{ta('Conferma nuova password')}</label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <button className="btn btn-primary" disabled={savingPassword}>
            {savingPassword ? ta('Aggiornamento…') : ta('Aggiorna password')}
          </button>
        </form>
      </div>

      {!isSupervisor && (
        <div className="admin-card" style={{ maxWidth: 420 }}>
          <h3 style={{ marginBottom: 14 }}>{ta('Verifica in due passaggi')}</h3>
          <p style={{ fontSize: '0.85rem', color: 'var(--muted-text)', marginBottom: 16 }}>
            {ta('Facoltativa: aggiunge un codice temporaneo generato da un\'app authenticator (Google Authenticator, Microsoft Authenticator, ecc.) al login, oltre alla password.')}
          </p>

          {twoFaError && <div className="form-error">{twoFaError}</div>}

          {twoFaStep === 'idle' && (
            <>
              <p style={{ fontSize: '0.85rem', marginBottom: 16 }}>
                {ta('Stato attuale:')} <strong>{totpEnabled ? ta('Attiva') : ta('Non attiva')}</strong>
              </p>
              {totpEnabled ? (
                <button type="button" className="btn btn-ghost" onClick={() => setTwoFaStep('disable')}>
                  {ta('Disattiva verifica in due passaggi')}
                </button>
              ) : (
                <button type="button" className="btn btn-primary" onClick={handleStartEnable2fa} disabled={twoFaBusy}>
                  {twoFaBusy ? ta('Preparazione…') : ta('Attiva verifica in due passaggi')}
                </button>
              )}
            </>
          )}

          {twoFaStep === 'setup' && (
            <>
              <p className="modal-subtitle" style={{ marginBottom: 10 }}>{ta('Inquadra il QR con la tua app authenticator.')}</p>
              {qrCodeDataUrl && (
                <div className="qr-frame">
                  <img src={qrCodeDataUrl} alt={ta('QR code per configurazione 2FA')} width={180} height={180} />
                </div>
              )}
              <div className="manual-key">{ta('Chiave manuale:')} {manualEntryKey}</div>
              <form onSubmit={handleConfirmEnable2fa}>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  className="totp-input"
                  placeholder="000000"
                  value={enableCode}
                  onChange={(e) => setEnableCode(e.target.value)}
                  autoFocus
                />
                <div className="btn-row" style={{ marginTop: 12 }}>
                  <button type="button" className="btn btn-ghost" onClick={cancelTwoFaFlow}>{ta('Annulla')}</button>
                  <button className="btn btn-primary" disabled={twoFaBusy}>{twoFaBusy ? ta('Verifica…') : ta('Conferma e attiva')}</button>
                </div>
              </form>
            </>
          )}

          {twoFaStep === 'disable' && (
            <form onSubmit={handleDisable2fa}>
              <div className="field">
                <label htmlFor="disable-2fa-password">{ta('Password attuale (per confermare)')}</label>
                <input
                  id="disable-2fa-password"
                  type="password"
                  value={disablePassword}
                  onChange={(e) => setDisablePassword(e.target.value)}
                  autoComplete="current-password"
                  autoFocus
                />
              </div>
              <div className="btn-row">
                <button type="button" className="btn btn-ghost" onClick={cancelTwoFaFlow}>{ta('Annulla')}</button>
                <button className="btn btn-primary" disabled={twoFaBusy}>{twoFaBusy ? ta('Disattivazione…') : ta('Disattiva')}</button>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
}
